angular.module('impactx.indexqueue').service("IndexQueueService", [
    'WebSocketService',
    'TranslationService',
    function (WebSocketService, TranslationService) {
        var init = function () {
            return WebSocketService.init("indexqueue").then(function () {
                WebSocketService.send({currentTask: "connect"});
            });
        };

        var send = WebSocketService.send;
        var close = WebSocketService.close;
        var getLastMessage = WebSocketService.getLastMessage;
        var getStatus = WebSocketService.getStatus;

        var getStatusMessage = function () {
            switch (getStatus()) {
                case WebSocketService.statusModes.none:
                    return TranslationService.get('notConnected');
                case WebSocketService.statusModes.init:
                    return TranslationService.get('connecting');
                case WebSocketService.statusModes.transmitting:
                    return TranslationService.get('updating');
                case WebSocketService.statusModes.connected:
                    return TranslationService.get('connected');
                case WebSocketService.statusModes.error:
                    return TranslationService.get('errorWhileConnecting');
                default:
                    return TranslationService.get('notConnected');
            }
        };

        var isProgressing = function () {
            return getStatus() <= WebSocketService.statusModes.transmitting;
        };
        var isConnected = function () {
            return getStatus() == WebSocketService.statusModes.connected;
        };

        var hasError = function () {
            return getStatus() == WebSocketService.statusModes.error;
        };

        return {
            init: init,
            send: send,
            getLastMessage: getLastMessage,
            close: close,
            getStatusMessage: getStatusMessage,
            getStatus: getStatus,
            isProgressing: isProgressing,
            isConnected: isConnected,
            hasError: hasError
        };
    }
]);